import type { CalculationApiInput } from './CalculationApiInput';
import type { HouseApiInput } from './HouseApiInput';

export interface LeaveToLetApiInput {
  readonly currentHouseValue: number;
  readonly expectedRentAmount: number;
  readonly futureLivingSituation: FutureLivingSituation;
  readonly futureMonthlyCosts?: number;
  readonly createHouseInput?: HouseApiInput;
  readonly createCalculationInput: CalculationApiInput;
  readonly contractID?: string;
}

export enum FutureLivingSituation {
  WillBuyHouse = 'willBuyHouse',
  BoughtHouse = 'boughtHouse',
  WillRentHouse = 'willRentHouse',
  LivingIn = 'livingIn'
}
